/* tslint:disable */
/* eslint-disable */
/**
 * TurboClaim API
 * TurboClaim API for insurance claim management. Includes claims, documents, estimates, supplements, billing, and chat operations. Authentication is JWT-based bearer token. 
 *
 * The version of the OpenAPI document: 1.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Result of accepting an invitation
 * @export
 * @interface AcceptInviteResponse
 */
export interface AcceptInviteResponse {
    /**
     * 
     * @type {boolean}
     * @memberof AcceptInviteResponse
     */
    success: boolean;
    /**
     * 
     * @type {number}
     * @memberof AcceptInviteResponse
     */
    companyId: number;
    /**
     * 
     * @type {string}
     * @memberof AcceptInviteResponse
     */
    message: string;
}

/**
 * Check if a given object implements the AcceptInviteResponse interface.
 */
export function instanceOfAcceptInviteResponse(value: object): value is AcceptInviteResponse {
    if (!('success' in value) || value['success'] === undefined) return false;
    if (!('companyId' in value) || value['companyId'] === undefined) return false;
    if (!('message' in value) || value['message'] === undefined) return false;
    return true;
}

export function AcceptInviteResponseFromJSON(json: any): AcceptInviteResponse {
    return AcceptInviteResponseFromJSONTyped(json, false);
}

export function AcceptInviteResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): AcceptInviteResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'success': json['success'],
        'companyId': json['companyId'],
        'message': json['message'],
    };
}

export function AcceptInviteResponseToJSON(json: any): AcceptInviteResponse {
    return AcceptInviteResponseToJSONTyped(json, false);
}

export function AcceptInviteResponseToJSONTyped(value?: AcceptInviteResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'success': value['success'],
        'companyId': value['companyId'],
        'message': value['message'],
    };
}

